import { FC, useEffect, useState } from 'react'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { ConfirmationModal } from 'featureSliced/features/ConfirmationModal'
import { AnimationData } from 'featureSliced/shared/utils/animations'
import { loadAnimation } from 'featureSliced/shared/utils/loadAnimation'

type LoggedInSuccessProps = {
  saveReceipt: () => Promise<void>
  isSaveLoading: boolean
  closeParentModal: () => void
}

export const LoggedInSuccess: FC<LoggedInSuccessProps> = ({
  saveReceipt,
  isSaveLoading,
  closeParentModal,
}) => {
  // Hooks
  const t = useTranslations()
  const isUserAuth = useMySelector((state) => state.auth.isLoggedIn)
  const appTheme = useMySelector((state) => state.app.interfaceStyles.appTheme)
  const [ordersHistoryAnimation, setOrdersHistoryAnimation] =
    useState<AnimationData | null>(null)

  useEffect(() => {
    if (!isUserAuth) return

    loadAnimation(`${appTheme}/historyGuide.json`, (error) => {
      console.error('Failed to load orders history animation:', error)
    }).then(setOrdersHistoryAnimation)
  }, [isUserAuth])

  return (
    <ConfirmationModal
      text={t('receipt.paymentOrdersHistory')}
      animationJSON={ordersHistoryAnimation}
      onCancel={closeParentModal}
      onConfirm={saveReceipt}
      isBigAnimationIncluded
      cancelText={t('buttons.close')}
      okText={t('buttons.save')}
      isLoading={isSaveLoading}
    />
  )
}
